<template>
 <el-col :span="24" class="toolbar">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout="total,sizes, prev, pager, next,jumper"
      :total="totalPage" style="float:right;">
    </el-pagination>
 </el-col>
</template>
<script>
export default {
  props: {
    totalPage: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit("pageSizeCallBack", val);
    },
    handleCurrentChange(val) {
      this.$emit("currentPageCallBack", val);
    }
  }
};
</script>

